import { useEffect, useRef } from 'react';

/**
 * Drop-in replacement for setInterval that pauses when the tab is hidden.
 * Pass delay=null to disable. When the tab becomes visible again, fires
 * immediately so data doesn't wait for the next tick.
 */
export function useVisibilityAwareInterval(
  callback: () => void,
  delay: number | null,
  fireOnResume = true
) {
  const savedCallback = useRef(callback);
  savedCallback.current = callback;

  useEffect(() => {
    if (delay === null) return;

    const tick = () => {
      if (!document.hidden) savedCallback.current();
    };

    const id = setInterval(tick, delay);

    const onVisible = () => {
      if (!document.hidden && fireOnResume) savedCallback.current();
    };
    document.addEventListener('visibilitychange', onVisible);

    return () => {
      clearInterval(id);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [delay, fireOnResume]);
}
